import React from "react";

const MinusIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 4"
            fill="none"
        >
            <path
                d="M14.4286 0.65625H1.57143C0.979799 0.65625 0.5 1.05779 0.5 1.55292V2.44958C0.5 2.94471 0.979799 3.34625 1.57143 3.34625H14.4286C15.0202 3.34625 15.5 2.94471 15.5 2.44958V1.55292C15.5 1.05779 15.0202 0.65625 14.4286 0.65625Z"
                fill="white"
            />
        </svg>
    );
};

export default MinusIcon;
